import React from 'react';

export const ExportIcon = (props: any) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12" height="12" width="12" {...props}>
    <title>export</title>
    <g className="nc-icon-wrapper" strokeWidth="1" fill="#5b2f91" stroke="#5b2f91">
      <path
        d="M11.5,11.5H1.5a1,1,0,0,1-1-1V.5"
        fill="none"
        stroke="#5b2f91"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <polyline
        points="6.5 0.5 11.5 0.5 11.5 5.5"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        data-color="color-2"
      />
      <line
        x1="11.5"
        y1="0.5"
        x2="5.5"
        y2="6.5"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        data-color="color-2"
      />
    </g>
  </svg>
);
